/* eslint-disable import/prefer-default-export */
import Translations from '@helpers/translations'
import { ReturnsProduct } from '@api/returns/types'
import {
  isAllowedProductCategoryBySku,
  returnsAnalytics,
  returnsClickEvent
} from '@components/returns/helpers'
import Dropdown from '@components/ui/formElements/Dropdown'
import { Button } from '@components/ui/Button'
import { Values, ReasonListItem } from '@components/returns/types'
import ExchangeNotification from '../../shared/ExchangeNotification'
import { PartialState, ValuesState } from '../../index'
import FormWrapper from '../../shared/FormWrapper'
import styles from '../../shared/styles.module.scss'
import { checkStoreIs } from '@helpers/env'

type ReasonStepProps = {
  selectedProduct: ReturnsProduct
  values: Values
  reasonList: ReasonListItem[]
  setSelection: (sizes: PartialState<ValuesState>) => void
  onExchange: (args: {
    step: number
    savedFitsizes?: PartialState<ValuesState['sizes']>
  }) => void
  onUpdate: () => void
  isLastStep: boolean
}

export function ReasonStep({
  selectedProduct,
  values,
  reasonList,
  setSelection,
  onUpdate,
  onExchange,
  isLastStep
}: ReasonStepProps) {
  const selectedReason = values.reason
  const buttonText = isLastStep
    ? Translations.localise('pages.returns.done')
    : 'Next'

  const { isMTO } = selectedProduct
  const isUS = checkStoreIs('us')

  const handleUpdate = () => {
    returnsClickEvent({
      label: buttonText
    })
    onUpdate()
  }

  const handleOnMainReasonSelection = (
    selection: Record<string, string | number>
  ) => {
    const reason = Number(selection.reason)
    setSelection({
      reason,
      reason_detail: []
    })
    const reasonLabel =
      (reasonList.find(reasonListItem => reasonListItem.value === reason) || {})
        .label || ''
    returnsAnalytics('Return Reason Selected', {
      color: selectedProduct.title,
      name: selectedProduct.product_type,
      product_id: selectedProduct.product_id,
      return_type: values.method,
      return_reason: reasonLabel
    })
  }

  const handleOnExchange = ({
    sizes,
    step
  }: {
    sizes?: PartialState<ValuesState['sizes']>
    step: number
  }) => {
    if (sizes) {
      setSelection({ sizes })
      onExchange({ step: 1, savedFitsizes: sizes })
    } else {
      onExchange({ step })
    }
  }

  const matchesAllowedProductCategory = selectedProduct?.sku
    ? isAllowedProductCategoryBySku(selectedProduct.sku)
    : true

  return (
    <>
      <FormWrapper title="Reason for refund">
        <Dropdown
          defaultValue="Please Select"
          placeholder="Please Select"
          classes={`${styles.returnsForm__dropdown} dropdown--wide dropdown__returns`}
          selectedClasses={`dropdown--capitalize dropdown--left ${
            !selectedReason && 'dropdown--grey'
          }`}
          list={reasonList}
          selection={selectedReason}
          setSelection={handleOnMainReasonSelection}
          optionClasses="list__option--capitalize list__option--left list__option--returns"
          id="reason"
        />
        {!isUS && !isMTO && matchesAllowedProductCategory && (
          <ExchangeNotification
            type="refund"
            reason={selectedReason}
            productSizes={selectedProduct?.sizes}
            productType={selectedProduct.product_type}
            onExchange={handleOnExchange}
          />
        )}
      </FormWrapper>
      <Button
        disabled={!selectedReason}
        classes={styles.returnsForm__button}
        variant="primary"
        fullWidth="always"
        onClick={handleUpdate}
      >
        {buttonText}
      </Button>
    </>
  )
}
